import { useEffect, useState } from "react";

const RAHMA_OPEN_KEY = "rahma-chat-open";
const wasRahmaChatOpen = () => {
  try { return window.sessionStorage.getItem(RAHMA_OPEN_KEY) === "true"; }
  catch { return false; }
};

export default function useHomeInteractions() {
  const [isRahmaOpen, setIsRahmaOpen] = useState(wasRahmaChatOpen);
  const [isDonationOpen, setIsDonationOpen] = useState(false);
  const [isZakatOpen, setIsZakatOpen] = useState(false);
  const [selectedDonation, setSelectedDonation] = useState({
    title: "Donation",
    type: "category",
    typeLabel: "Category",
    caseNo: "",
    amount: "100",
  });
  useEffect(() => {
    document.title = "Tarahum Charity Foundation";
    document.body.className = "home-page";
    return () => {
      document.body.className = "";
    };
  }, []);

  useEffect(() => {
    const chat = document.getElementById("rahmaChat");
    chat?.classList.toggle("show", isRahmaOpen);
    chat?.classList.toggle("active", isRahmaOpen);
    try { window.sessionStorage.setItem(RAHMA_OPEN_KEY, String(isRahmaOpen)); } catch {}
  }, [isRahmaOpen]);

  useEffect(() => {
    document.getElementById("dntpopups")?.classList.toggle("active", isDonationOpen);
  }, [isDonationOpen]);

  useEffect(() => {
    document.getElementById("zakatPopup")?.classList.toggle("active", isZakatOpen);
  }, [isZakatOpen]);

  useEffect(() => {
    const calculateZakat = () => {
      const amountInput = document.getElementById("zakatAmount");
      const resultBox = document.getElementById("zakatResult");
      if (!amountInput || !resultBox) return;

      const amount = Number.parseFloat(amountInput.value);
      resultBox.textContent = Number.isFinite(amount) && amount > 0
        ? `AED ${(amount * 0.025).toFixed(2)}`
        : "AED 0.00";
    };

    const resetZakat = () => {
      const amountInput = document.getElementById("zakatAmount");
      const resultBox = document.getElementById("zakatResult");
      if (amountInput) {
        amountInput.value = "";
        amountInput.focus();
      }
      if (resultBox) resultBox.textContent = "AED 0.00";
    };

    const onClick = (event) => {
      if (event.target.closest?.("#closeZakatPopup")) {
        event.preventDefault();
        setIsZakatOpen(false);
        return;
      }

      if (event.target.closest?.("#calculateZakatBtn")) {
        event.preventDefault();
        calculateZakat();
        return;
      }

      if (event.target.closest?.("#resetZakatBtn")) {
        event.preventDefault();
        resetZakat();
        return;
      }

      if (event.target.id === "zakatPopup") {
        setIsZakatOpen(false);
      }
    };

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsZakatOpen(false);
        return;
      }

      if (event.key === "Enter" && event.target.id === "zakatAmount") {
        event.preventDefault();
        calculateZakat();
      }
    };

    document.addEventListener("click", onClick);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("click", onClick);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, []);

  useEffect(() => {
    const header = document.querySelector(".header-new");
    const onScroll = () => header?.classList.toggle("is-sticky", window.scrollY > 150);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const openBtn = document.getElementById("nwOpenMenu");
    const closeBtn = document.getElementById("nwCloseMenu");
    const mobileMenu = document.getElementById("nwMobileMenu");
    const overlay = document.getElementById("nwOverlay");

    const open = () => {
      mobileMenu?.classList.add("active");
      overlay?.classList.add("active");
    };
    const close = () => {
      mobileMenu?.classList.remove("active");
      overlay?.classList.remove("active");
    };

    openBtn?.addEventListener("click", open);
    closeBtn?.addEventListener("click", close);
    overlay?.addEventListener("click", close);
    return () => {
      openBtn?.removeEventListener("click", open);
      closeBtn?.removeEventListener("click", close);
      overlay?.removeEventListener("click", close);
    };
  }, []);


  useEffect(() => {
    const onDonationClick = (event) => {
      const trigger = event.target.closest?.(".openDonation");
      if (!trigger) return;
      event.preventDefault();

      const amountInput = trigger.closest?.(".crtic-form, .post-item, .stry-card, .critical-detail-donate, .project-donate-row")?.querySelector?.("input[type='number']");
      const selectedAmount = amountInput?.value || trigger.dataset.donationAmount || "";

      setSelectedDonation({
        id: trigger.dataset.donationId || "",
        catid: trigger.dataset.catid || "0",
        subcatid: trigger.dataset.subcatid || "0",
        projectid: trigger.dataset.projectid || "0",
        title: trigger.dataset.donationTitle || "",
        type: trigger.dataset.donationType || "category",
        typeLabel: trigger.dataset.donationTypeLabel || "Category",
        caseNo: trigger.dataset.caseNo || "",
        categoryTitle: trigger.dataset.categoryTitle || "",
        amount: selectedAmount,
      });
      setIsDonationOpen(true);
    };

    document.addEventListener("click", onDonationClick);
    return () => document.removeEventListener("click", onDonationClick);
  }, []);

  useEffect(() => {
    const onDonationModalClick = (event) => {
      const closeTrigger = event.target.closest?.("#closeDonation, .close-popup, #doneBtn");
      if (closeTrigger) {
        event.preventDefault();
        setIsDonationOpen(false);
        return;
      }

      if (event.target.classList?.contains("donation-overlay")) {
        setIsDonationOpen(false);
        return;
      }

      const methodCard = event.target.closest?.(".method-card");
      if (!methodCard || !methodCard.closest("#dntpopups")) return;

      const methodList = methodCard.closest(".method-list");
      methodList?.querySelectorAll(".method-card").forEach((card) => {
        card.classList.remove("active");
      });
      methodCard.classList.add("active");
    };

    const onDonationModalKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsDonationOpen(false);
      }
    };

    document.addEventListener("click", onDonationModalClick);
    document.addEventListener("keydown", onDonationModalKeyDown);
    return () => {
      document.removeEventListener("click", onDonationModalClick);
      document.removeEventListener("keydown", onDonationModalKeyDown);
    };
  }, []);

  useEffect(() => {
    if (window.matchMedia?.("(pointer: coarse)").matches) return undefined;

    const cursor = document.createElement("div");
    cursor.className = "cb-cursor -normal";
    const cursorText = document.createElement("div");
    cursorText.className = "cb-cursor-text";
    cursor.appendChild(cursorText);
    document.body.appendChild(cursor);

    let mouseX = -100;
    let mouseY = -100;
    let cursorX = mouseX;
    let cursorY = mouseY;
    let frameId = 0;
    let stickTarget = null;

    const addState = (state) => state && cursor.classList.add(state);
    const removeState = (state) => state && cursor.classList.remove(state);

    const animate = () => {
      cursorX += (mouseX - cursorX) * 0.22;
      cursorY += (mouseY - cursorY) * 0.22;
      cursor.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0)`;
      frameId = window.requestAnimationFrame(animate);
    };

    const move = (event) => {
      if (stickTarget) {
        const rect = stickTarget.getBoundingClientRect();
        const stickX = rect.left + rect.width / 2;
        const stickY = rect.top + rect.height / 2;
        mouseX = stickX - (stickX - event.clientX) * 0.15;
        mouseY = stickY - (stickY - event.clientY) * 0.15;
      } else {
        mouseX = event.clientX;
        mouseY = event.clientY;
      }
      addState("-visible");
    };

    const onMouseOver = (event) => {
      const pointerTarget = event.target.closest?.("a, input, textarea, button, select, [role='button']");
      if (pointerTarget) addState("-pointer");

      const cursorTarget = event.target.closest?.("[data-cursor]");
      if (cursorTarget?.dataset.cursor) addState(cursorTarget.dataset.cursor);

      const textTarget = event.target.closest?.("[data-cursor-text]");
      if (textTarget?.dataset.cursorText) {
        cursorText.textContent = textTarget.dataset.cursorText;
        addState("-text");
      }

      const stickSelector = event.target.closest?.("[data-cursor-stick]")?.dataset.cursorStick;
      stickTarget = stickSelector ? document.querySelector(stickSelector) : null;
    };

    const onMouseOut = (event) => {
      const pointerTarget = event.target.closest?.("a, input, textarea, button, select, [role='button']");
      if (pointerTarget) removeState("-pointer");

      const cursorTarget = event.target.closest?.("[data-cursor]");
      if (cursorTarget?.dataset.cursor) removeState(cursorTarget.dataset.cursor);

      const textTarget = event.target.closest?.("[data-cursor-text]");
      if (textTarget?.dataset.cursorText) {
        cursorText.textContent = "";
        removeState("-text");
      }

      if (event.target.closest?.("[data-cursor-stick]")) {
        stickTarget = null;
      }
    };

    const hide = () => removeState("-visible");
    const activate = () => addState("-active");
    const deactivate = () => removeState("-active");

    document.addEventListener("mousemove", move);
    document.addEventListener("mouseover", onMouseOver);
    document.addEventListener("mouseout", onMouseOut);
    document.addEventListener("mouseleave", hide);
    document.addEventListener("mousedown", activate);
    document.addEventListener("mouseup", deactivate);
    frameId = window.requestAnimationFrame(animate);

    return () => {
      window.cancelAnimationFrame(frameId);
      document.removeEventListener("mousemove", move);
      document.removeEventListener("mouseover", onMouseOver);
      document.removeEventListener("mouseout", onMouseOut);
      document.removeEventListener("mouseleave", hide);
      document.removeEventListener("mousedown", activate);
      document.removeEventListener("mouseup", deactivate);
      cursor.remove();
    };
  }, []);

  useEffect(() => {
    const counters = Array.from(document.querySelectorAll(".counter"));
    if (!counters.length) return undefined;

    const formatNumber = (value) => Math.floor(value).toLocaleString("en-US");

    const getCounterTarget = (counter) => Number(
      counter.getAttribute("data-counter-target") || counter.textContent.replace(/,/g, "")
    );

    const animateCounterValue = (counter) => {
      const target = getCounterTarget(counter);
      if (!Number.isFinite(target) || counter.dataset.counterDone === "true") return;

      counter.dataset.counterTarget = String(target);
      counter.dataset.counterDone = "true";
      counter.textContent = "0";

      const duration = 3200;
      const startTime = performance.now();
      const startValue = 0;

      const tick = (now) => {
        const progress = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const value = startValue + (target - startValue) * eased;
        counter.textContent = formatNumber(value);

        if (progress < 1) {
          window.requestAnimationFrame(tick);
        } else {
          counter.textContent = formatNumber(target);
        }
      };

      window.requestAnimationFrame(tick);
    };

    const prepareCounters = () => {
      Array.from(document.querySelectorAll(".counter")).forEach((counter) => {
        const target = getCounterTarget(counter);
        if (Number.isFinite(target)) {
          counter.dataset.counterTarget = String(target);
          counter.dataset.counterDone = "false";
          counter.textContent = "0";
        }
      });
    };

    prepareCounters();

    if (!("IntersectionObserver" in window)) {
      counters.forEach(animateCounterValue);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          animateCounterValue(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.35 }
    );

    counters.forEach((counter) => observer.observe(counter));

    const refreshCounters = () => {
      observer.disconnect();
      prepareCounters();
      Array.from(document.querySelectorAll(".counter")).forEach((counter) => {
        observer.observe(counter);
        const rect = counter.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          animateCounterValue(counter);
        }
      });
    };

    window.addEventListener("home-counter-refresh", refreshCounters);
    return () => {
      window.removeEventListener("home-counter-refresh", refreshCounters);
      observer.disconnect();
    };
  }, []);

  return {
    selectedDonation,
    onOpenDonationPopup: (donation) => {
      if (donation) setSelectedDonation(donation);
      setIsDonationOpen(true);
    },
    onCloseDonationPopup: () => setIsDonationOpen(false),
    onToggleRahmaChat: () => setIsRahmaOpen((value) => !value),
    onOpenZakatPopup: () => setIsZakatOpen(true),
    onCloseZakatPopup: () => setIsZakatOpen(false),
  };
}
